/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Google Analytics 4 イベント送信ユーティリティ
 * GA4 の測定IDは index.html の G-XXXXXXXXXX を実際のIDに置き換えてください
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const sendEvent = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

/**
 * 電話番号クリックイベントを送信する
 * @param location クリックされた場所の識別子（例: 'hero', 'contact'）
 */
export const trackPhoneClick = (location: string) => {
  sendEvent('phone_click', {
    event_category: 'engagement',
    event_label: location,
    phone_number: '0120-676-337',
  });
};

/**
 * フォーム送信成功イベントを送信する
 * @param formName フォームの識別子（例: 'contact_form'）
 */
export const trackFormSubmit = (formName: string) => {
  sendEvent('form_submit', {
    event_category: 'conversion',
    event_label: formName,
    form_name: formName,
  });
};

/**
 * LINEリンククリックイベントを送信する
 * @param location クリックされた場所の識別子（例: 'hero', 'contact', 'footer'）
 */
export const trackLineClick = (location: string) => {
  sendEvent('line_click', {
    event_category: 'engagement',
    event_label: location,
    link_type: 'line',
  });
};

/**
 * メールリンククリックイベントを送信する
 * @param location クリックされた場所の識別子（例: 'contact', 'footer'）
 */
export const trackEmailClick = (location: string) => {
  sendEvent('email_click', {
    event_category: 'engagement',
    event_label: location,
    email_address: 'info@botan-buy.com',
  });
};
